import {Drawer, DrawerProps} from './components/drawer'
import {createOverlay} from '@chakra-ui/react'

export const drawer = createOverlay<DrawerProps>(props => {
  const drawers = drawer.getSnapshot().filter(d => Boolean(d.open))
  const drawersCount = drawers.length
  const currentDrawerIndex = drawers.findIndex(d => d.id === props.id)
  const inverseIndex = props?.blockInverseIndex ? 0 : drawersCount - currentDrawerIndex - 1 // the index starting from end to beginning of the drawers list

  return (
    <Drawer
      {...props}
      contentProps={{
        ...props.contentProps,
        ...(inverseIndex
          ? {
              transform: `translateX(-${inverseIndex}rem) scale(${1 - (inverseIndex * 2) / 100})`,
              transition: 'all 200ms ease-in-out',
            }
          : undefined),
      }}
    />
  )
})
